import Image from 'next/image'
import * as React from 'react'

import { cn } from '@/lib/utils'

interface GeneralV1FooterProps {
  logoSrc?: string
  className?: string
}

/**
 * General V1 minimal footer — Figma node 1:1655.
 *
 * Light layout: logo/copyright left, mandatory "Powered by Edunodes" right.
 * No hide flag for the powered-by attribution.
 */
export function GeneralV1Footer({
  logoSrc = '/templates/general-v1/assets/edunodes-logo-blue.svg',
  className,
}: GeneralV1FooterProps) {
  const year = new Date().getFullYear()

  return (
    <footer
      className={cn(
        'border-t border-gray-100 bg-[var(--gv1-bg-surface)] py-[25px]',
        className
      )}
      data-testid="gv1-footer"
    >
      <div className="gv1-container flex flex-col items-end justify-between gap-4 sm:flex-row">
        {/* Left: logo + copyright */}
        <div className="flex items-end gap-3">
          {logoSrc && (
            <Image
              src={logoSrc}
              alt="Logo"
              width={92}
              height={22}
              className="h-[22px] w-auto"
            />
          )}
          <span
            className="text-xs text-[var(--gv1-text-muted)]"
            style={{ fontFamily: 'var(--gv1-font-body)' }}
            suppressHydrationWarning
          >
            © {year} All rights reserved.
          </span>
        </div>

        {/* Right: powered-by (not owner-editable) */}
        <span
          className="text-xs text-[var(--gv1-text-muted)]"
          style={{ fontFamily: 'var(--gv1-font-body)' }}
        >
          Powered by Edunodes
        </span>
      </div>
    </footer>
  )
}
